.home__image {
  width: 100%;
}

.home__list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
